/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { ServiceEndpoint } from 'client-code/sls-service-endpoints';
import { SlsServiceGlobalEndpointsService } from './SlsServiceGlobalEndpointsService';
import { Log } from '../logging/Log';
import { IDefaultServices } from '../interfaces/IDefaultServices';
import { MsoDefaultBrandingUiBundleService } from './MsoDefaultBrandingUiBundleService';

export class DefaultServices implements IDefaultServices {
    private TAG: string = 'DefaultServices';

    private slsBaseUrl: string;

    constructor(url: string) {
        this.slsBaseUrl = url;
    }

    getBrandingUiInfoForKey = (key: string) => {
        return new MsoDefaultBrandingUiBundleService().getBrandingUiInfoForKey(key);
    };

    async fetchGlobalEndPoints(): Promise<ServiceEndpoint[]> {
        try {
            return await new SlsServiceGlobalEndpointsService(
                this.slsBaseUrl,
            ).fetchSlsGlobalEndpoints();
        } catch (error) {
            Log.e(this.TAG, 'fetchGlobalEndPoints()', error);
            throw error;
        }
    }

    async fetchMsoDefaultBrandingUiInfo(): Promise<void> {
        try {
            return await new MsoDefaultBrandingUiBundleService().fetchMsoDefaultBrandingUiInfo();
        } catch (error) {
            Log.e(this.TAG, 'fetchMsoDefaultBrandingUiInfo', error);
            throw error;
        }
    }
}
